/**
 * Количество позиции — строка, как её ввёл человек. Клиент только проверяет
 * форму (договор C3b: больше 0, до трёх знаков, меньше ста тысяч; штучный —
 * целое) и шагает целыми единицами; сумму не считает.
 */
const QUANTITY = /^\d{1,5}(?:[.,]\d{1,3})?$/

/** Предел службы — `99 999.999`. */
const MAX_INTEGER_DIGITS = 5

export function normalizeQuantity(text: string): string {
  return text.trim().replace(',', '.')
}

/** Почему количество не годится — словами; `null` — годится. */
export function quantityError(text: string, isWeight: boolean | null): string | null {
  const value = normalizeQuantity(text)
  if (value === '') return 'Укажите количество'
  if (!QUANTITY.test(value)) return 'Количество — число больше нуля, до трёх знаков после точки'
  const [whole = '', fraction = ''] = value.split('.')
  if (/^0*$/.test(whole) && /^0*$/.test(fraction)) return 'Количество должно быть больше нуля'
  if (whole.replace(/^0+/, '').length > MAX_INTEGER_DIGITS) return 'Слишком большое количество'
  if (isWeight !== true && !/^0*$/.test(fraction)) return 'Штучный товар — только целое количество'
  return null
}

/** Число для тела запроса. Строка уже проверена: до трёх знаков, без потерь в JSON. */
export function quantityNumber(text: string): number {
  return Number(normalizeQuantity(text))
}

/** Шаг ±1 у целого количества; у дробного — не шагаем (весовой товар вводят числом). */
export function stepQuantity(text: string, delta: 1 | -1): string | null {
  const value = normalizeQuantity(text)
  if (!/^\d{1,5}$/.test(value)) return null
  const next = Number.parseInt(value, 10) + delta
  return next >= 1 && next <= 99_999 ? String(next) : null
}
